import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerSignAgreementApiCallSuccess } from 'redux/actions';
import { TRIGGER_SIGN_AGREEMENT_API } from 'redux/actionTypes';
import { apiCall } from 'services';

function* triggerSignAgreementApiCall(actions) {
	const { callback } = actions;
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url: API_CONSTANT.URL.AGREEMENT,
		method: 'POST',
	});
	if (api && api.data) {
		const apiData = api.data;
		callback && callback(apiData);
		yield put(triggerSignAgreementApiCallSuccess(apiData));
	}
}

export default function* triggerSignAgreementApiCallSaga() {
	yield takeEvery(TRIGGER_SIGN_AGREEMENT_API, triggerSignAgreementApiCall);
}
